<!-- 储值卡合同/私教合同/租赁柜合同 -->
<template >
    <div class="new-contract-dialog">
        <el-dialog :visible.sync="showVisible" :title="title" left @close="close" >
            <div class="msph-dialog-title bg-gray mg-10">
                <!-- public -->
                <p class="msph-dialog-title-p">
                    {{ $t('Common.name') }}：{{ client.clientName }}
                </p>
                <p class="msph-dialog-title-p">
                    {{ $t('Common.phone') }}：{{ client.clientPhone }}
                </p>
                <!-- 储值卡 -->
                <div v-if="contract.name !== 'storeValue'">
                    <p class="msph-dialog-title-p">
                        {{ $t('Common.card_number') }}：{{ client.cardNum }}
                    </p>
                    <p class="msph-dialog-title-p">
                        {{ $t('Member.has_zhong') }}：{{ client.cardNames }}
                    </p>
                    <p class="msph-dialog-title-p">
                        {{ $t('Member.start_end_date') }}：{{ client.validity }}
                    </p>
                </div>
                <!-- 私教 -->
                <div v-if="contract.name === 'personal'">
                    <div
                        @click="goPersonalCon"
                        class="cursor-pointer msph-dialog-title-p new-personal-blue">
                        {{ $t('Member.check_has') }}
                        {{ client.coachContractCount }}
                        {{ $t('Member.personal_contract') }}
                    </div>
                </div>
            </div>
            <el-form
                ref="form"
                :model="form"
                :rules="rules"
                :status-icon="true"
                label-position="right"
                label-width="120px"
                label-suffix=":">
                <el-form-item
                    :label="contract.name === 'storeValue' ? $t('Member.open_card_store') : $t('Member.sign_store')"
                    prop="storeId" >
                    <el-select
                        v-model="form.storeId"
                        @change="fetchSelect"
                        :placeholder="$t('Common.all_store2')"
                        class="w-full" clearable>
                        <el-option
                            v-for="(item, index) in stores"
                            :key="`${index}-${item.id}-${item.name}`"
                            :label="item.name"
                            :value="Number(item.id)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Member.saler')" prop="salesStaffId">
                    <el-select
                        @change="searchStaff = null"
                        v-model="form.salesStaffId"
                        :placeholder="$t('Common.please_choose')"
                        class="w-full" clearable>
                        <input
                            class="search-input-all"
                            type="text"
                            v-model="searchStaff"/>
                        <el-option
                            v-for="(item, index) in filterStaff"
                            :key="`${index}-${item.id}-${item.nickname}`"
                            :label="item.nickname"
                            :value="Number(item.id)"
                            :disabled="item.id === 'no'" />
                    </el-select>
                </el-form-item>
                <template v-if="contract.name==='personal'">
                    <el-form-item :label="$t('Course.coach')" prop="coachId">
                        <el-select
                            @change="fetchLesson"
                            v-model="form.coachId"
                            :placeholder="$t('Common.please_choose')"
                            class="w-full" clearable>
                            <input
                                class="search-input-all"
                                type="text"
                                v-model="searchCoach"/>
                            <el-option
                                v-for="(item, index) in filterCoach"
                                :key="`${index}-${item.id}-${item.nickname}`"
                                :label="item.nickname"
                                :value="Number(item.id)"
                                :disabled="item.id === 'no'" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('Course.name')" prop="lessonId">
                        <el-select
                            @change="fetchPriceLevel"
                            v-model="form.lessonId"
                            :placeholder="$t('Common.please_choose')"
                            class="w-full" clearable>
                        <el-option
                            v-for="(item, index) in constant.lessons"
                            :key="`${index}-${item.id}-${item.name}`"
                            :label="item.name"
                            :value="Number(item.id)"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('Member.price_level')" prop="lessonPriceId">
                        <el-select
                            @change="getAmtPrice"
                            v-model="form.lessonPriceId"
                            :placeholder="$t('Common.please_choose')"
                            class="w-full" clearable>
                            <el-option
                                v-for="(item, index) in constant.priceLevel"
                                :key="`${index}-${item.id}-${item.priceLevel}`"
                                :label="`${item.priceLevel}(${item.countInterval}节)`"
                                :value="Number(item.id)"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('Member.buy_count')" prop="count">
                        <el-input
                            type="number"
                            :placeholder="$t('Fill.buy_count_placeholder')"
                            v-model="form.count"
                            min="1"
                        />
                    </el-form-item>
                    <el-form-item :label="$t('Contract.start_time')" prop="startAt">
                        <el-date-picker
                        v-model="form.startAt"
                        type="date"
                        style="width:180px"
                        :placeholder="$t('Reception.Third.time_placeholder')"
                        value-format="yyyy-MM-dd"/>
                    </el-form-item>
                    <el-form-item :label="$t('Contract.end_time')" prop="endAt">
                        <el-date-picker
                        v-model="form.endAt"
                        type="date"
                        style="width:180px"
                        :placeholder="$t('Reception.Third.time_placeholder')"
                        value-format="yyyy-MM-dd"/>
                    </el-form-item>
                    <el-form-item
                        v-if="client.autoExtend"
                        label-width="340px"
                        prop="extendFactor"
                        :label="$t('Contract.tips')" >
                        <el-input
                            type="number"
                            style="width:60px;margin-left: -15px"
                            class="mr-2"
                            v-model="form.extendFactor"/>
                        <span style="font-size: 12px">({{ $t('Contract.tip2') }})</span>
                    </el-form-item>
                </template>
                <template v-if="contract.name==='storeValue'">
                    <el-form-item :label="$t('Contract.card_name')" prop="cardId">
                        <el-select
                            v-model="form.cardId"
                            :placeholder="$t('Common.please_choose')"
                            v-on:change="fetchCardInfo">
                            <input type="text" class="search-input-all" v-model="searchText"/>
                            <el-option
                                v-for="(item, index) in filterList"
                                :key="`${index}-${item.id}-${item.name}`"
                                :label="item.name"
                                :value="item.id"
                                :disabled="item.id === 'no'"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('Card.image')" v-if="cardInfo.image">
                        <div class="contract_card_show">
                            <img :src="cardInfo.image" >
                        </div>
                    </el-form-item>
                    <el-form-item
                        prop="supportStoreType"
                        :label="$t('Contract.support_store')"
                        v-if="cardInfo.supportStoreType">
                        {{ cardInfo.supportStoreDesc }}
                    </el-form-item>
                    <div v-if="cardInfo.supportStoreType === 2" class="box-1e">
                        <div>
                            <el-checkbox
                                class="label-name"
                                :indeterminate="isSupportIndeterminate"
                                v-model="checkAll"
                                @change="handleCheckAllChange"
                            >{{ $t('Course.check_all') }}</el-checkbox>
                            <div class="box-a">
                                <el-checkbox-group
                                    v-model="form.supportStoreIds"
                                    @change="handleCheckedSupportStoresChange">
                                    <el-checkbox
                                        v-for="(item, index) in cardInfo.supportStores"
                                        :label="item.storeId"
                                        :key="index"
                                    >{{item.storeName}}</el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </div>
                    </div>
                    <el-form-item prop="activeCardWayCode" :label="$t('Member.open_card_method')">
                        <el-select
                            v-model="form.activeCardWayCode"
                            :placeholder="$t('Member.open_card_placeholder')"
                            class="w-full"
                            clearable>
                            <el-option :label="$t('Card.Way.day')" :value="1"/>
                            <el-option :label="$t('Card.Way.date')" :value="3"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        :label="$t('Contract.start_time')"
                        v-if="form.activeCardWayCode === 3"
                        prop="startAt">
                        <el-date-picker
                            @change="addDate"
                            v-model="form.startAt"
                            type="date"
                            style="width:180px"
                            :placeholder="$t('Reception.Third.time_placeholder')"
                            value-format="yyyy-MM-dd"
                        />
                    </el-form-item>
                    <p v-if="contractEndAt" style="font-size:12px;margin: -10px 0 15px 120px">
                        {{ $t('Contract.end_time') }}:{{contractEndAt}}
                    </p>
                </template>

                <!-- 租赁柜 -->
                <template v-if="contract.name === 'locker'">
                    <el-form-item :label="$t('Contract.start_time')" prop="startAt">
                        <el-date-picker
                            v-model="form.startAt"
                            type="date"
                            style="width:180px"
                            :placeholder="$t('Reception.Third.time_placeholder')"
                            value-format="yyyy-MM-dd"/>
                    </el-form-item>
                    <el-form-item :label="$t('Reception.Fourth.area1')" prop="storeAreaId">
                        <el-select
                            v-model="form.storeAreaId"
                            :placeholder="$t('Common.please_choose')"
                            class="w-full" clearable>
                            <el-option
                                v-for="(item, index) in constant.areas"
                                :key="`${index}-${item.id}-${item.name}`"
                                :label="item.name"
                                :value="Number(item.id)"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('Common.cabinet_number')" prop="lockerCode">
                        <el-select
                            @change="getAmtPrice"
                            v-model="form.lockerCode"
                            filterable
                            remote
                            reserve-keyword
                            :placeholder="$t('Fill.cabinet_search')"
                            :remote-method="fetchLocker"
                            :loading="loading">
                            <el-option
                                v-for="(item, index) in constant.lockers"
                                :key="`${index}-${item.lockerCode}`"
                                :label="item.lockerCode"
                                :value="item.lockerCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('Week.lease_period')" prop="lease">
                        <el-input
                            type="number"
                            v-model="form.lease"
                            :placeholder="$t('Week.fill_lease_period')"
                            min="1"/>
                    </el-form-item>
                </template>
                <!-- 身份证号 prop="certNum" -->
                <el-form-item :label="$t('Sell.identity_number')" class="fitness-redItem">
                    <el-input
                        type="text"
                        v-model="form.certNum"
                        :placeholder="$t('Fill.identity_number_placeholder')"/>
                </el-form-item>
                <el-form-item prop="remark" :label="$t('Common.remark')">
                    <el-input type="textarea" v-model="form.remark"/>
                </el-form-item>
                <div style="border-top:1px solid #ccc; margin: 20px 0px 20px 0px;"></div>
                <el-form-item prop="contractNum" :label="$t('Contract.number')">
                    <el-input
                        type="text"
                        v-model="form.contractNum"
                        :placeholder="$t('Contract.fill_number')"
                        style="width:200px" class="mr-2"
                    />
                    <el-button
                        type="success"
                        v-if="autoContractNum"
                        @click="getAutoContractNum"
                    >{{ $t('Common.zidong') }}</el-button>
                </el-form-item>
                <el-form-item prop="baseAmt" :label="$t('Sell.Charge.base_amt')" >
                    <el-input
                        type="number"
                        style="width: 150px"
                        v-model="basicPrice"
                        :placeholder="$t('Fill.base_amt')"
                    /><span> {{ $t('Reception.Fifth.yuan') }}</span>
                </el-form-item>
                <el-form-item prop="discountAmt" :label="$t('Charge.discounted_price')">
                    <el-input
                        min="0"
                        type="number"
                        style="width: 150px"
                        v-model="form.discountAmt"
                        :placeholder="$t('Fill.discounted_price')"
                    /><span> {{ $t('Reception.Fifth.yuan') }}</span>
                </el-form-item>
                <el-form-item :label="$t('Charge.finally_money')">{{ calPrice }}
                     <span> {{ $t('Reception.Fifth.yuan') }}</span>
                </el-form-item>
                <el-form-item :label="$t('Charge.contract_deduction')" v-if="isDeposit">
                    <span>{{ client.prepayAmt }} {{ $t('Reception.Fifth.yuan') }}</span>
                </el-form-item>
                <el-form-item :label="$t('Charge.amount_to_be_paid')" v-if="isDeposit">
                    <span>{{ computedMoney }} {{ $t('Reception.Fifth.yuan') }}</span>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer"  style="text-align:center">
                <el-button
                    :disabled="isDeposit && form.baseAmt && form.baseAmt - Number(client.prepayAmt) < 0
                    || isDeposit && form.baseAmt && form.discountAmt
                    && form.baseAmt - Number(client.prepayAmt) - form.discountAmt < 0"
                    @click="submit"
                    type="primary">
                    {{ $t('Common.next_step') }}
                </el-button>
            </div>
        </el-dialog>
        <pay-form
            v-model="isPay"
            ref="pay"
            :contract="contractName"
            @close="closeAll" />
    </div>
</template>

<script>
import {
    Dialog,
    DatePicker,
    RadioGroup,
    Radio,
    CheckboxGroup,
    CheckboxButton,
    TimePicker,
    Row,
    Autocomplete,
} from 'element-ui';
import PayForm from '@/components/Dialog/Client/PayForm';
import filterRole from '@/mixins/filterRole.js';
import timeMixin from '@/mixins/timeMixin.js';

export default {
    // contract - 合同名字，isDeposit - 是否定金合同
    props: ['contract', 'isDeposit', 'infoType', 'data', 'contractNum'],
    components: {
        ElDialog: Dialog,
        ElDatePicker: DatePicker,
        ElRadioGroup: RadioGroup,
        ElRadio: Radio,
        ElCheckboxGroup: CheckboxGroup,
        ElCheckboxButton: CheckboxButton,
        ElTimePicker: TimePicker,
        ElRow: Row,
        ElAutocomplete: Autocomplete,
        PayForm,
    },
    mixins: [filterRole, timeMixin],
    data() {
        return {
            searchStaff: '',
            contractEndAt: '',
            autoContractNum: false,
            url: '',
            constant: [
                { lessons: [] },
                { priceLevel: [] },
                { areas: [] },
                { lockers: [] },
            ],
            coaches: [],
            contractName: '',
            checkAll: false,
            isSupportIndeterminate: false,
            cardInfo: {},
            searchText: '',
            clients: [],
            client: {},
            staffs: [],
            stores: [],
            cards: [],
            loading: false,
            showVisible: true,
            finalPrice: 0,
            title: '',
            lockerAmt: '',
            form: {
                baseAmt: null,
            },
            rules: {},
            isClose: true,
            isPay: null,
            basicPrice: 0,
            searchCoach: null,
        };
    },
    watch: {
        'visible'(val) {
            if (!val) this.resetForm();
        },
        'form.count'(val) {
            if (!val) return false;
            this.form.startAt = this.form.startAt || new Date();
            const total = Number(val) * 7;
            const end = this.AddWeeks(new Date(this.form.startAt), total);
            this.form.endAt = end;

            const all = Number(val) * Number(this.form.baseAmt);
            this.basicPrice = all;
        },
        'form.lease'(val) {
            const all = Number(val) * Number(this.form.baseAmt);
            this.basicPrice = all;
        },
    },
    computed: {
        computedMoney: function () {
            let money;
            const {form} = this;
            if (form.baseAmt && !form.discountAmt) money = form.baseAmt - Number(this.client.prepayAmt);
            else if (form.baseAmt && form.discountAmt) {
                money = form.baseAmt - Number(this.client.prepayAmt) - form.discountAmt;
            }
            return money;
        },
        calPrice: {
            get: function () {
                let money;
                const basic = Number(this.basicPrice);
                if (!this.isDeposit) money = basic - Number(this.form.discountAmt);
                else if (this.isDeposit && this.form.discountAmt) {
                    money = basic - Number(this.form.discountAmt) - Number(this.client.prepayAmt);
                }
                if (money < 0) money = 0;
                return money;
            },
            set: function (newValue) {
                return newValue;
            },
        },
        filterList() {
            if (!this.searchText) return this.cards;
            const arr = this.cards.filter(item =>
                item.name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
            return arr.length ? arr : [{id: 'no', name: this.$t('Common.data_not_found')}];
        },
        filterStaff() {
            if (!this.searchStaff) return this.staffs;
            const arr = this.staffs.filter(item =>
                item.nickname.toLowerCase().indexOf(this.searchStaff.toLowerCase()) > -1);
            return arr.length ? arr : [{id: 'no', nickname: this.$t('Common.data_not_found')}];
        },
        filterCoach() {
            if (!this.searchCoach) return this.coaches;
            const arr = this.coaches.filter(item =>
                item.nickname.toLowerCase().indexOf(this.searchCoach.toLowerCase()) > -1);
            return arr.length ? arr : [{id: 'no', nickname: this.$t('Common.data_not_found')}];
        },
    },
    created() {
        this.open();
    },
    methods: {
        filterTime(date) {
            const year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            // const hour = date.getHours();
            let minutes = date.getMinutes();
            if (month < 10) month = `0${month}`;
            if (day < 10) day = `0${day}`;
            if (minutes < 10) minutes = `0${minutes}`;

            return `${year}-${month}-${day}`;
        },
        close() {
            if (this.isClose) this.$emit('close');
        },
        closeAll() {
            this.isClose = true;
            this.close();
        },
        resetForm() {
            this.form = {
                baseAmt: null,
            };
            this.rules = {};
            this.$refs.form.resetFields();
            this.$refs.form.clearValidate();
        },
        createdData() {
            if (this.contract.name === 'storeValue') {
                // 新建储值卡合同
                this.form = {
                    clientId: null,
                    storeId: null,
                    salesStaffId: null,
                    cardId: null,
                    activeCardWayCode: null,
                    startAt: null,
                    supportStoreIds: [],
                    remark: null,
                    contractNum: null,
                    baseAmt: null,
                    discountAmt: null,
                    certNum: null,
                };
                this.rules = {
                    storeId: { required: true, message: this.$t('Common.store_placeholder') },
                    salesStaffId: { required: true, message: this.$t('Choose.saler2') },
                    cardId: { required: true, message: this.$t('Choose.card_zhong') },
                    activeCardWayCode: { required: true, message: this.$t('Member.open_card_placeholder') },
                    supportStoreType: { required: true, message: this.$t('Choose.has_store_type') },
                    contractNum: { required: true, message: this.$t('Contract.fill_number'), type: 'string' },
                    baseAmt: { required: true, message: this.$t('Fill.base_amt') },
                    startAt: {required: true, message: this.$t('Contract.start_date') },
                    certNum: { required: true, message: this.$t('Fill.identity_number_placeholder') },
                };
            } else if (this.contract.name === 'personal') {
                // 新建私教合同
                this.form = {
                    storeId: null,
                    clientId: null,
                    salesStaffId: null,
                    coachId: null,
                    lessonId: null,
                    lessonPriceId: null,
                    count: null,
                    startAt: null,
                    endAt: null,
                    remark: null,
                    contractNum: null,
                    baseAmt: null,
                    discountAmt: null,
                    certNum: null,
                    extendFactor: null,
                };
                this.rules = {
                    storeId: { required: true, message: this.$t('Common.store_placeholder') },
                    salesStaffId: { required: true, message: this.$t('Choose.saler2') },
                    coachId: { required: true, message: this.$t('Choose.coach') },
                    lessonId: { required: true, message: this.$t('Choose.lesson') },
                    lessonPriceId: { required: true, message: this.$t('Choose.price_level') },
                    count: { required: true, message: this.$t('Fill.buy_count_placeholder') },
                    startAt: {required: true, message: this.$t('Contract.start_date') },
                    endAt: { required: true, message: this.$t('Choose.contract_end') },
                    contractNum: { required: true, message: this.$t('Contract.fill_number'), type: 'string' },
                    baseAmt: { required: true, message: this.$t('Fill.base_amt') },
                    extendFactor: { required: true, message: this.$t('Fill.custom_coefficient') },
                    certNum: { required: true, message: this.$t('Fill.identity_number_placeholder') },
                };
            } else if (this.contract.name === 'locker') {
                // 新建租赁柜合同
                this.form = {
                    clientId: null,
                    storeId: null,
                    salesStaffId: null,
                    startAt: null,
                    storeAreaId: null,
                    lockerCode: null,
                    lease: null,
                    remark: null,
                    contractNum: null,
                    baseAmt: null,
                    discountAmt: null,
                    certNum: null,
                };
                this.rules = {
                    storeId: { required: true, message: this.$t('Common.store_placeholder') },
                    salesStaffId: { required: true, message: this.$t('Choose.saler2') },
                    startAt: { required: true, message: this.$t('Contract.start_date') },
                    storeAreaId: { required: true, message: this.$t('Reception.Fourth.choose_area_place') },
                    lockerCode: { required: true, message: this.$t('Choose.caninet') },
                    lease: { required: true, message: this.$t('Week.fill_lease_period2') },
                    contractNum: { required: true, message: this.$t('Contract.fill_number'), type: 'string' },
                    baseAmt: { required: true, message: this.$t('Fill.base_amt') },
                    certNum: { required: true, message: this.$t('Fill.identity_number_placeholder') },
                };
            }
        },
        getTitle() {
            if (this.contract.name === 'storeValue') {
                this.title = this.$t('Stats.Card.value_card');
                this.contractName = 'storeValue';
                this.url = 'contract/cz-card';
            } else if (this.contract.name === 'personal') {
                this.title = this.$t('Sell.personal');
                this.contractName = 'personal';
                this.url = 'contract/coach';
            } else if (this.contract.name === 'locker') {
                this.title = this.$t('Stats.Card.locker');
                this.contractName = 'locker';
                this.url = 'contract/locker';
            }
        },
        open() {
            // this.data 代表客户id
            // this.infotType 代表合同类型 1-会籍入会,2-会籍续会,3-储值卡,4-私教
            this.getTitle();
            this.createdData();
            this.fetchClent(this.data, this.infoType);
        },
        fetchClent(id, type) {
            API.get(`client/${id}/init-contract`, {
                params: {
                    type: type,
                    prepayContractNum: this.isDeposit ? this.contractNum : '',
                },
            }).then(res => {
                if (!res.autoExtend && this.contract.name === 'personal') delete this.rules.extendFactor;
                this.client = res;
                if (res.certNum) this.form.certNum = res.certNum;
                this.fetchStore();
            });
        },
        fetchStore() {
            API.get('store/list').then(res => {
                this.stores = res;
            });
        },
        fetchArea() {
            API.get('area', {
                params: {
                    storeId: this.form.storeId,
                },
            }).then(res => {
                this.$set(this.constant, 'areas', res);
            });
        },
        fetchLocker(val) {
            API.get('locker', {
                params: {
                    areaId: this.form.storeAreaId,
                    date: !this.form.startAt.length ? this.filterTime(this.form.startAt) : this.form.startAt,
                    lockerCode: val,
                },
            }).then(res => {
                this.$set(this.constant, 'lockers', res);
            });
        },
        fetchData(data) {
            this.finalPrice = Number(data.baseAmt) - Number(data.discountAmt);
        },
        fetchSelect() {
            this.stores.forEach(el => {
                if (el.id === this.form.storeId) {
                    this.autoContractNum = el.autoContractNum;
                }
            });
            this.fetchSalers();
            this.fetchLesson();
            if (this.contract.name === 'storeValue') this.fetchCard();
            else if (this.contract.name === 'personal') this.fetchCoach();
            else if (this.contract.name === 'locker') this.fetchArea();

            this.$set(this.constant, 'priceLevel', []);
            this.$set(this.constant, 'lessons', []);
            this.form.lessonPriceId = null;
            this.form.lessonId = null;

        },
        fetchLesson() {
            this.searchCoach = null;
            this.form.lessonId = null;
            this.form.lessonPriceId = null;
            API.get('lesson/coach/list', {
                params: {
                    coachId: this.form.coachId,
                    active: true,
                },
            }).then(res => {
                this.$set(this.constant, 'lessons', res);
                this.$set(this.constant, 'priceLevel', []);
            });
        },
        fetchPriceLevel() {
            API.get(`lesson/coach/${this.form.lessonId}/price-list`, {
                params: {
                    storeId: this.form.storeId,
                },
            }).then(res => {
                console.log('fetchPriceLevel', res);
                this.$set(this.constant, 'priceLevel', res);
                this.$set(this.form, 'baseAmt', res.normalPrice);
            });
        },
        getAmtPrice() {
            if (this.contract.name === 'personal') {
                this.constant.priceLevel.forEach(el => {
                    if (el.id === this.form.lessonPriceId) {
                        this.form.baseAmt = el.normalPrice;
                    }
                });
            }
            if (this.contract.name === 'locker') {
                this.constant.lockers.forEach(el => {
                    if (el.lockerCode === this.form.lockerCode) {
                        this.lockerAmt = el.price;
                        this.$set(this.form, 'baseAmt', this.lockerAmt);
                    }
                });
            }
            this.basicPrice = this.form.baseAmt;
        },
        async fetchCoach() {
            this.loading = true;
            const ids = [7, 8];
            const {storeId} = this.form;
            this.coaches = await this.filterRole(null, ids, storeId, null, 'work');
            this.loading = false;
        },
        async fetchSalers() {
            this.loading = true;
            const ids = this.contract.name === 'personal' ? ['7, 8, 10'] : null;
            const {storeId} = this.form;
            this.staffs = await this.filterRole(null, ids, storeId, null, 'work');
            this.loading = false;
        },
        async fetchCardInfo(val) {
            this.searchText = null;
            this.loading = true;
            await API.get(`stored-value-card/${val}/card-info`).then(res => {
                this.cardInfo = res;
                this.form.supportStoreType = res.supportStoreType;
                this.form.baseAmt = res.basePrice;
                if (this.contract.name === 'storeValue') this.basicPrice = this.form.baseAmt;
            });
            API.get(`stored-value-card/${val}`).then(res => {
                this.cardInfo.validPeriod = res.validPeriod;
            }).finally(() => {
                this.loading = false;
            });
        },
        fetchCard() {
            this.loading = true;
            API.get(`stored-value-card/list?storeId=${this.form.storeId}`)
                .then(res => {
                    this.cards = res;
                    if (this.cards.length < 1) {
                        this.cardInfo = {};
                        this.form.supportStoreType = '';
                        this.form.baseAmt = '';
                        this.form.cardId = '';
                    }
                }).finally(() => {
                    this.loading = false;
                });
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                this.postData();
            });
        },
        postData() {
            const form = Object.assign({}, this.form);
            form.clientId = this.client.clientId;
            form.baseAmt = this.basicPrice;
            if (this.contract.name === 'personal') {
                if (!form.startAt.length) form.startAt = this.filterTime(new Date(form.startAt));
                else if (!form.endAt.length) form.endAt = this.filterTime(new Date(form.endAt));
            }
            API.post(`${this.url}`, form)
                .then(() => {
                    this.isClose = false;
                    this.showVisible = false;
                    this.$refs.pay.open(this.form.contractNum);
                })
                .finally(() => {
                    this.loading = false;
                })
                .catch(err => {
                    $ele.$message.error(err);
                });
        },
        handleCheckAllChange(val) {
            this.form.supportStoreIds = val ? this.stores.map(el => el.id) : [];
            this.isSupportIndeterminate = false;
        },
        handleCheckedSupportStoresChange(value) {
            const checkedCount = value.length;
            this.checkAll = checkedCount === this.stores.length;
            this.isSupportIndeterminate = checkedCount > 0 && checkedCount < this.stores.length;
        },
        getAutoContractNum() {
            this.loading = true;
            API.get(`store/${this.form.storeId}/gen-contract-num`).then(res => {
                this.$set(this.form, 'contractNum', res);
            }).finally(() => {
                this.loading = false;
            });
        },
        addDate(val) {
            const date = new Date(val);
            date.setDate(date.getDate() + this.cardInfo.validPeriod);
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const day = date.getDate();
            this.contractEndAt = `${year}-${month}-${day}`;
        },
        // 私教查看购买的私教合同
        goPersonalCon() {
            const keyword = this.client.clientPhone;
            const {location} = window;
            const link = `${location.origin}/admin/sell/index?activeName=personal&keyword=${keyword}`;
            if (this.client.coachContractCount) window.open(link);
        },
    },
};
</script>

<style lang="scss">
.new-contract-dialog {
    .el-dialog {
        max-height: 800px;
        width: 540px;
    }
    .el-dialog__body {
        max-height: 700px;
    }
    .el-dialog--center .el-dialog__body {
        padding: 25px 25px 0;
    }
    .delete-img {
        top: 0px;
        right: 0px;
        color: gray;
        font-size: 14px;
    }
    .el-dialog__title {
        font-size: 16px;
    }
    .el-dialog__header {
        line-height: 40px;
        background-color: #f2f2f2;
        border-bottom: 1px solid #e6e6e6;
        font-size: 14px;
        color: #333;
        text-align: left;
        padding: 0 45px 0 15px;
    }
    .el-checkbox {
        margin-right: 20px;
        margin-left: 0px;
    }
    .msph-dialog-title {
        border: 1px solid #e6e6e6;
        padding-left: 10px;
        background: #f7f7f7 !important;
        margin-bottom: 15px;
        padding: 6px 14px;
    }
    .msph-dialog-title-p {
        width: 100% !important;
        font-size: 12px;
        margin: 10px 0;
    }
    .box-1e {
        position: relative;
        left: 120px;
        margin-bottom: 15px!important;
        padding: 15px 15px 0 15px;
        background: #eee;
        width: 75%;
        min-height: 150px;
    }
    .box-a {
        margin-left: 20px;
        padding: 10px 15px;
        background: #fff!important;
        min-height: 70px!important;
        overflow: scroll;
    }
    .contract_card_show {
        display: block;
        overflow: hidden;
        width: 160px;
        height: 100px;
        border-radius: 5px;
    }
    .new-personal-blue {
        color: #05abef;
    }
}
</style>
